/**
 * Random Variant Color Cycling v3
 *
 * On page load, finds product cards with data-color-variants attribute
 * and randomly picks a different color for each card. True random
 * distribution — no deterministic hashing, different every page load.
 */
(function () {
  'use strict';

  function init() {
    var cards = document.querySelectorAll('product-card[data-color-variants]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      try {
        var variants = JSON.parse(card.getAttribute('data-color-variants'));
        if (!variants || variants.length <= 1) return;

        // Pick a random variant
        var randomIndex = Math.floor(Math.random() * variants.length);
        var chosen = variants[randomIndex];

        if (!chosen || !chosen.image) return;

        // Swap primary image
        var primaryImg = card.querySelector('.product-card__image--primary');
        if (primaryImg) {
          primaryImg.src = chosen.image;
          primaryImg.srcset = '';
        }

        // Swap secondary image to a different random color
        var secondaryImg = card.querySelector('.product-card__image--secondary');
        if (secondaryImg && variants.length > 1) {
          var secondIndex = randomIndex;
          // Make sure secondary is different from primary
          while (secondIndex === randomIndex && variants.length > 1) {
            secondIndex = Math.floor(Math.random() * variants.length);
          }
          if (variants[secondIndex] && variants[secondIndex].image) {
            secondaryImg.src = variants[secondIndex].image;
            secondaryImg.srcset = '';
          }
        }

        // Swap links to point to the chosen variant
        var links = card.querySelectorAll('a[href*="/products/"]');
        Array.prototype.forEach.call(links, function (link) {
          if (chosen.url) link.href = chosen.url;
        });

        // Save chosen color to card for Globo Swatch sync
        if (chosen.color) {
          card.setAttribute('data-chosen-color', chosen.color.toLowerCase());
        }

      } catch (e) {
        // Silently fail — card stays with default image
      }
    });

    // MutationObserver to sync Globo Swatch once it renders
    var observer = new MutationObserver(function(mutations, obs) {
      var syncedCards = 0;
      cards.forEach(function(card) {
        if (card.hasAttribute('data-synced')) {
          syncedCards++;
          return;
        }
        var chosenColor = card.getAttribute('data-chosen-color');
        if (!chosenColor) {
          card.setAttribute('data-synced', 'true');
          syncedCards++;
          return;
        }

        // Try to find the Globo swatch container
        var globoSwatch = card.querySelector('[class*="globo"] .product_card_swatch_list');
        if (globoSwatch) {
          // Mark as syncing immediately to show swatches (prevent opacity: 0)
          card.setAttribute('data-syncing', 'true');
          // Look for the swatch that matches the color
          var swatches = globoSwatch.querySelectorAll('li, li a, li span, li div');
          for (var i = 0; i < swatches.length; i++) {
            var el = swatches[i];
            var value = el.getAttribute('data-value') || el.getAttribute('title') || el.getAttribute('aria-label') || (el.innerText || '').trim();
            if (value && value.toLowerCase() === chosenColor) {
              // Found it! 
              var clickable = el.tagName === 'A' || el.tagName === 'LI' ? el : el.querySelector('a') || el;
              
              // Remove title/tooltips to prevent hover tooltip
              var allElements = globoSwatch.querySelectorAll('*');
              allElements.forEach(function(t) { 
                t.removeAttribute('title'); 
                t.removeAttribute('data-tooltip');
                t.removeAttribute('aria-label');
                t.removeAttribute('data-tippy-content');
              });

              // Instead of clicking (which triggers Globo's visual change),
              // directly add the 'active' or 'selected' class that Globo uses
              // and mark all others as inactive
              var allSwatches = globoSwatch.querySelectorAll('li, li a, li span');
              allSwatches.forEach(function(s) {
                s.classList.remove('active', 'selected', 'is-active', 'globo-selected', 'current');
              });
              
              // Add active state to the matched swatch
              el.classList.add('active', 'selected');
              if (el.parentElement && el.parentElement.tagName === 'LI') {
                el.parentElement.classList.add('active', 'selected');
              }
              
              // Single click immediately to sync Globo's internal state (once only, no interval)
              // Delay it by 50ms so the active class is applied first
              setTimeout(function() {
                clickable.click();
              }, 50);
              
              card.setAttribute('data-synced', 'true');
              break;
            }
          }
          // if we couldn't find a matching color, still mark as synced
          if (!card.hasAttribute('data-synced')) {
             card.setAttribute('data-synced', 'true');
          }
        }
      });
      
      // Stop observing if all cards are synced
      if (syncedCards >= cards.length) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Globally strip tooltip attributes from all Globo swatches continuously
    // This ensures no tooltip appears on hover for any swatch.
    setInterval(function() {
      var allGlowSwatches = document.querySelectorAll('[class*="globo"] .product_card_swatch_list *, .globo-swatch-product-card *');
      for (var i = 0; i < allGlowSwatches.length; i++) {
        var t = allGlowSwatches[i];
        if(t.hasAttribute('title')) t.removeAttribute('title');
        if(t.hasAttribute('data-tooltip')) t.removeAttribute('data-tooltip');
        if(t.hasAttribute('aria-label')) t.removeAttribute('aria-label');
        if(t.hasAttribute('data-tippy-content')) t.removeAttribute('data-tippy-content');
      }
      
      // Also hide any active tippy boxes that might have snuck through
      var tippyBoxes = document.querySelectorAll('.tippy-popper, .tippy-box');
      for (var j = 0; j < tippyBoxes.length; j++) {
        var box = tippyBoxes[j];
        if (box.innerText && box.innerText.trim().length < 20) {
           box.style.display = 'none';
        }
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================
   QUICK-BUY MODAL — GLOBO COLOR SWATCH FIX
   Forces Globo Color Swatch to re-initialize
   inside the quick-buy modal after dynamic
   content is loaded.
   ============================================= */
(function() {
  'use strict';

  // ---- DIAGNOSTIC: Scan window for GLO globals ----
  function scanGloboGlobals() {
    var found = [];
    var keys = Object.keys(window);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (/[Gg]lobo|[Gg]cw|[Ss]watch/i.test(k) && typeof window[k] !== 'undefined') {
        found.push({ key: k, type: typeof window[k] });
      }
    }
    if (found.length > 0) {
      console.group('%c[GLO Debug] Detected GLO objects on window:', 'color:#e98da0;font-weight:bold');
      found.forEach(function(f) {
        console.log('  window.' + f.key + '  →  ' + f.type);
      });
      console.groupEnd();
    } else {
      console.warn('[GLO Debug] No GLO objects found on window. The app may not be installed or loaded.');
    }
    return found;
  }

  // ---- CALL ANY GLO FUNCTION ----
  function findAndCallGloboApi(container) {
    var called = false;

    // 1) Scan keys found by diagnostic
    var keys = Object.keys(window);
    var tried = [];

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!/[Gg]lobo|[Gg]cw|[Ss]watch/i.test(k)) continue;

      var val = window[k];
      if (typeof val === 'function') {
        tried.push(k + '()');
        try {
          val.call(window, container);
          called = true;
        } catch(e) {
          try { val.call(window); called = true; } catch(e2) {}
        }
      } else if (val && typeof val === 'object') {
        // Try common method names on this object
        var methods = ['initProductPage', 'init', 'initSwatches', 'reload', 'refresh', 'render'];
        for (var m = 0; m < methods.length; m++) {
          if (typeof val[methods[m]] === 'function') {
            tried.push(k + '.' + methods[m] + '()');
            try {
              val[methods[m]].call(val, container);
              called = true;
            } catch(e) {
              try { val[methods[m]].call(val); called = true; } catch(e2) {}
            }
          }
        }
      }
    }

    // 2) Try known top-level GCW/GloboSwatchPlugin patterns
    var knownPatterns = [
      { obj: window.GloboSwatchPlugin, fns: ['initProductPage', 'initSwatches', 'reload', 'refresh', 'init'] },
      { obj: window.GloboSwatch, fns: ['init', 'refresh', 'reload'] },
      { obj: window.GCW, fns: ['init', 'refresh', 'reload'] },
      { obj: window.globoSwatchPlugin, fns: ['init', 'refresh'] }
    ];
    for (var p = 0; p < knownPatterns.length; p++) {
      var pat = knownPatterns[p];
      if (!pat.obj) continue;
      for (var f = 0; f < pat.fns.length; f++) {
        var fnName = pat.fns[f];
        if (typeof pat.obj[fnName] === 'function' && tried.indexOf(pat.obj.constructor.name + '.' + fnName + '()') === -1) {
          tried.push(pat.obj.constructor.name + '.' + fnName + '()');
          try { pat.obj[fnName].call(pat.obj, container); called = true; } catch(e) {
            try { pat.obj[fnName].call(pat.obj); called = true; } catch(e2) {}
          }
        }
      }
    }

    return called;
  }

  // ---- DISPATCH SHOPIFY EVENTS ----
  function dispatchShopifyEvents(sectionEl) {
    try {
      // Standard Shopify event — apps listen on document, not documentElement
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: {
          sectionId: sectionEl ? sectionEl.id || 'quick-buy-product' : 'quick-buy-product'
        }
      }));
      // Custom event from theme.js
      document.dispatchEvent(new CustomEvent('theme:quick-buy:loaded', {
        bubbles: true,
        detail: { container: sectionEl }
      }));
    } catch(e) {}
  }

  // ---- TRIGGER VARIANT INPUT CHANGES ----
  function triggerVariantInputs(container) {
    if (!container) return;
    // Find all variant radio inputs and selects
    var radios = container.querySelectorAll('input[type="radio"][name*="option"], input[data-option-position]');
    if (radios.length > 0) {
      var checked = container.querySelector('input[type="radio"][name*="option"]:checked, input[data-option-position]:checked');
      if (checked) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var selects = container.querySelectorAll('select[name*="option"]');
    if (selects.length > 0) {
      selects[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ---- MUTATION OBSERVER: watch for GLO swatches ----
  function observeGloboSwatches(container, callback) {
    // Selectors GLO commonly uses for its container output
    var globoSelectors = [
      '.globo-swatch-product-page',
      '.globo-swatch-container',
      '.globo-swatch-list',
      '.globo-style--*',
      '[class*="globo-swatch"]',
      '[class*="globo_swatch"]',
      'ul.swatch-view',
      '.swatch-view'
    ];

    // Check if GLO swatches already exist
    for (var s = 0; s < globoSelectors.length; s++) {
      try {
        if (container.querySelector(globoSelectors[s])) {
          callback(true);
          return null;
        }
      } catch(e) {}
    }

    // Observe for them to appear
    var observer = new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        for (var n = 0; n < mutations[m].addedNodes.length; n++) {
          var node = mutations[m].addedNodes[n];
          if (node.nodeType === 1) {
            for (var s = 0; s < globoSelectors.length; s++) {
              try {
                if (node.matches && node.matches(globoSelectors[s])) {
                  callback(true);
                  observer.disconnect();
                  return;
                }
                if (node.querySelector && node.querySelector(globoSelectors[s])) {
                  callback(true);
                  observer.disconnect();
                  return;
                }
              } catch(e) {}
            }
          }
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
    return observer;
  }

  // ---- MAIN HANDLER ----
  function initGloboInQuickBuyModal(modal) {
    // Run diagnostics once on first use
    if (!window._globoScanned) {
      window._globoScanned = true;
      scanGloboGlobals();
    }

    requestAnimationFrame(function() {
      var content = modal.querySelector('.quick-buy-modal__content') ||
                    modal.querySelector('.quick-buy-modal__info-wrapper') ||
                    modal;

      if (!content) return;

      // Step 1: Dispatch Shopify events so GLO knows new content arrived
      dispatchShopifyEvents(content);

      // Step 2: Try calling any GLO API functions directly
      var apiCalled = findAndCallGloboApi(content);

      // Step 3: Watch for GLO swatches to appear and hide native variant picker
      var obs = observeGloboSwatches(content, function(swatchesFound) {
        if (swatchesFound) {
          console.log('%c[GLO] Swatches detected in quick-buy modal.', 'color:#4CAF50;font-weight:bold');
          // Hide the theme's native variant-picker so only Globo swatches show
          var nativePickers = modal.querySelectorAll('variant-picker');
          for (var i = 0; i < nativePickers.length; i++) {
            nativePickers[i].style.display = 'none';
          }
          // Ensure the hidden variant ID input is enabled for form submission
          // (Globo will manage variant selection via its own UI)
          var forms = modal.querySelectorAll('form[action*="/cart/add"]');
          for (var f = 0; f < forms.length; f++) {
            var hiddenId = forms[f].querySelector('input[name="id"][disabled]');
            if (hiddenId) {
              hiddenId.removeAttribute('disabled');
            }
          }
        }
        // Cleanup observer once detected
        if (obs) obs.disconnect();
      });

      // Step 4: Apply Globo's color config to native swatches in quick-buy
      // Since Globo can't inject into dynamically loaded modals, we read its
      // global config and apply those colors to the theme's native .color-swatch elements
      applyGloboColorsToNativeSwatches(modal, content);

      // Step 5: Retry with delays for async GLO init
      [300, 800, 1500, 3000].forEach(function(delay) {
        setTimeout(function() {
          dispatchShopifyEvents(content);
          findAndCallGloboApi(content);
          if (delay >= 1500) {
            triggerVariantInputs(content);
          }
        }, delay);
      });
    });
  }

  // ---- APPLY GLOBO COLORS TO NATIVE SWATCHES ----
  // Reads Globo's actual rendered swatch colors from the collection card
  // (where Globo has already injected) and applies them to the theme's
  // native .color-swatch elements in the quick-buy modal
  function applyGloboColorsToNativeSwatches(modal, content) {
    // Strategy 1: Find the product card that contains this quick-buy modal
    // and extract Globo's actual rendered colors from there
    var globoColors = extractColorsFromProductCard(modal);

    if (!globoColors || globoColors.length === 0) {
      console.log('[GLO Quick-Buy] No Globo colors found on product card.');
      return;
    }

    // Store colors on the modal so we can re-apply them after re-renders
    modal.setAttribute('data-globo-colors', JSON.stringify(globoColors));

    // Apply colors function that can be called multiple times
    var applyColors = function() {
      var swatches = content.querySelectorAll('.color-swatch');
      if (swatches.length === 0) return 0;

      var applied = 0;
      for (var i = 0; i < swatches.length && i < globoColors.length; i++) {
        var swatch = swatches[i];
        var globoColor = globoColors[i];

        if (globoColor) {
          if (globoColor.type === 'image') {
            swatch.style.setProperty('--swatch-background', 'url(' + globoColor.value + ')', 'important');
          } else {
            swatch.style.setProperty('--swatch-background', 'linear-gradient(to right, ' + globoColor.value + ', ' + globoColor.value + ')', 'important');
          }
          // Mark swatch as Globo-styled to prevent re-application
          swatch.setAttribute('data-globo-styled', 'true');
          applied++;
        }
      }
      return applied;
    };

    // Apply colors initially
    var applied = applyColors();

    if (applied > 0) {
      console.log('%c[GLO Quick-Buy] Applied ' + applied + ' Globo colors to native swatches.', 'color:#4CAF50;font-weight:bold');
    }

    // Set up a MutationObserver to re-apply colors when variant picker re-renders
    // (which happens when Globo swatches are clicked or variants change)
    var observer = new MutationObserver(function(mutations) {
      // Check if any new .color-swatch elements were added or modified
      var needsReapply = false;
      for (var m = 0; m < mutations.length; m++) {
        var mutation = mutations[m];
        // Check added nodes
        for (var n = 0; n < mutation.addedNodes.length; n++) {
          var node = mutation.addedNodes[n];
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('color-swatch') && !node.hasAttribute('data-globo-styled')) {
              needsReapply = true;
              break;
            }
            if (node.querySelector && node.querySelector('.color-swatch:not([data-globo-styled])')) {
              needsReapply = true;
              break;
            }
          }
        }
        // Check if style attributes were removed (indicating a re-render)
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var target = mutation.target;
          if (target.classList && target.classList.contains('color-swatch')) {
            var currentStyle = target.getAttribute('style') || '';
            // If the swatch doesn't have our Globo color anymore, re-apply
            if (!currentStyle.includes('--swatch-background') || !target.hasAttribute('data-globo-styled')) {
              needsReapply = true;
              break;
            }
          }
        }
      }

      if (needsReapply) {
        console.log('%c[GLO Quick-Buy] Variant picker re-rendered, re-applying Globo colors...', 'color:#FF9800;font-weight:bold');
        var reapplied = applyColors();
        if (reapplied > 0) {
          console.log('%c[GLO Quick-Buy] Re-applied ' + reapplied + ' Globo colors after re-render.', 'color:#4CAF50;font-weight:bold');
        }
      }
    });

    // Observe the content area for changes to color swatches
    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Store observer on modal for cleanup
    modal._globoColorObserver = observer;
  }

  // Extract actual rendered colors from Globo swatches on the product card
  // that triggered this quick-buy modal (matched by position/index)
  function extractColorsFromProductCard(modal) {
    var colors = [];

    // The quick-buy-modal element sits inside a product-card
    var productCard = modal.closest('product-card, .product-card');
    if (!productCard) {
      // Try finding by the modal's ID — the trigger button has aria-controls pointing to it
      var modalId = modal.id || modal.getAttribute('id');
      if (modalId) {
        var triggerBtn = document.querySelector('[aria-controls="' + modalId + '"]');
        if (triggerBtn) {
          productCard = triggerBtn.closest('product-card, .product-card');
        }
      }
    }

    // Also try: the modal might be a sibling of the trigger button
    if (!productCard) {
      var prevSibling = modal.previousElementSibling;
      if (prevSibling && prevSibling.tagName === 'BUTTON') {
        productCard = prevSibling.closest('product-card, .product-card');
      }
    }

    // Last resort: find by product handle in the modal's attributes
    if (!productCard) {
      var handle = modal.getAttribute('handle') || '';
      var handlePart = handle.split('?')[0]; // e.g. "linen-pants"
      if (handlePart) {
        // Find any product card that links to this product
        var allCards = document.querySelectorAll('product-card, .product-card');
        for (var c = 0; c < allCards.length; c++) {
          var cardLink = allCards[c].querySelector('a[href*="/' + handlePart + '"]');
          if (cardLink) {
            productCard = allCards[c];
            break;
          }
        }
      }
    }

    if (!productCard) {
      console.log('[GLO Quick-Buy] Could not find product card for modal.');
      return colors;
    }

    // Find Globo's rendered swatch list on this card
    var globoSwatchList = productCard.querySelector('.product_card_swatch_list') ||
                          productCard.querySelector('[class*="globo"] ul') ||
                          productCard.querySelector('[class*="globo-swatch"] ul');
    if (!globoSwatchList) {
      console.log('[GLO Quick-Buy] No Globo swatch list found on product card.');
      return colors;
    }

    // Build the Globo color map from the app's global config FIRST —
    // this is the authoritative source of hex codes set in the Globo admin.
    var globoColorMap = buildGloboColorMap();
    
    console.log('[GLO] Built Globo color map with ' + Object.keys(globoColorMap).length + ' entries:', globoColorMap);

    var swatchItems = globoSwatchList.querySelectorAll('li');
    console.log('[GLO] Found ' + swatchItems.length + ' swatch items on product card');
    
    for (var i = 0; i < swatchItems.length; i++) {
      var li = swatchItems[i];
      var colorEl = li.querySelector('a, span, div') || li;
      var color = null;
      
      console.log('[GLO] Processing swatch ' + i + ':', {
        li: li.outerHTML.substring(0, 200),
        dataValue: li.getAttribute('data-value') || colorEl.getAttribute('data-value'),
        title: li.getAttribute('title') || colorEl.getAttribute('title'),
        ariaLabel: li.getAttribute('aria-label') || colorEl.getAttribute('aria-label'),
        innerText: (colorEl.innerText || '').trim()
      });

      // Strategy 1: Match swatch name against Globo's config color map.
      // The <li> or its child element carries the color name in data-value, title, or aria-label.
      var swatchName = (
        li.getAttribute('data-value') ||
        colorEl.getAttribute('data-value') ||
        li.getAttribute('title') ||
        colorEl.getAttribute('title') ||
        li.getAttribute('aria-label') ||
        colorEl.getAttribute('aria-label') ||
        li.getAttribute('data-color') ||
        colorEl.getAttribute('data-color') ||
        (colorEl.innerText || '').trim() ||
        ''
      ).toLowerCase().trim();

      if (swatchName && globoColorMap[swatchName]) {
        color = globoColorMap[swatchName];
      }
      
      // Also try to extract from data attributes on colorEl
      if (!color) {
        var dataColor = colorEl.getAttribute('data-color-value') || 
                        colorEl.getAttribute('data-hex') ||
                        colorEl.getAttribute('data-bg-color') ||
                        colorEl.getAttribute('data-bg') ||
                        colorEl.getAttribute('data-swatch-color');
        if (dataColor) {
          if (dataColor.indexOf('http') === 0 || dataColor.indexOf('//') === 0) {
            color = { type: 'image', value: dataColor };
          } else if (dataColor.indexOf('#') === 0 || dataColor.indexOf('rgb') === 0) {
            color = { type: 'color', value: dataColor };
          }
        }
      }
      
      // Try the <a> or <span> element's style attribute
      if (!color) {
        var linkEl = li.querySelector('a[style*="background"]');
        if (linkEl) {
          var linkStyle = linkEl.getAttribute('style') || '';
          var linkHex = linkStyle.match(/#[0-9a-fA-F]{3,8}/);
          var linkRgb = linkStyle.match(/rgba?\([^)]+\)/);
          var linkUrl = linkStyle.match(/url\(["']?([^"')]+)["']?\)/);
          if (linkUrl) {
            color = { type: 'image', value: linkUrl[1] };
          } else if (linkHex) {
            color = { type: 'color', value: linkHex[0] };
          } else if (linkRgb) {
            color = { type: 'color', value: linkRgb[0] };
          }
        }
      }

      // Strategy 2: Check inline style for hex/rgb/url (Globo sometimes uses inline styles)
      if (!color) {
        var inlineStyle = colorEl.getAttribute('style') || '';
        if (!inlineStyle) {
          inlineStyle = li.getAttribute('style') || '';
        }
        
        console.log('[GLO] Swatch ' + i + ' inline style:', inlineStyle);

        var urlMatch = inlineStyle.match(/url\(["']?([^"')]+)["']?\)/);
        var hexMatch = inlineStyle.match(/#[0-9a-fA-F]{3,8}/);
        var rgbMatch = inlineStyle.match(/rgba?\([^)]+\)/);

        if (urlMatch) {
          color = { type: 'image', value: urlMatch[1] };
        } else if (hexMatch) {
          color = { type: 'color', value: hexMatch[0] };
        } else if (rgbMatch) {
          color = { type: 'color', value: rgbMatch[0] };
        }
      }

      // Strategy 3: Computed background (last resort, may not paint in time)
      if (!color) {
        try {
          var computed = window.getComputedStyle(colorEl);
          var bgVal = computed.backgroundColor;
          var bgImg = computed.backgroundImage;
          
          console.log('[GLO] Swatch ' + i + ' computed:', {
            backgroundColor: bgVal,
            backgroundImage: bgImg
          });
          
          if (bgVal && bgVal !== 'rgba(0, 0, 0, 0)' && bgVal !== 'transparent') {
            color = { type: 'color', value: bgVal };
          }
          if (!color && bgImg && bgImg !== 'none') {
            var computedUrlMatch = bgImg.match(/url\(["']?([^"')]+)["']?\)/);
            if (computedUrlMatch) {
              color = { type: 'image', value: computedUrlMatch[1] };
            }
          }
        } catch(e) {
          console.warn('[GLO] Error getting computed style for swatch ' + i + ':', e);
        }
      }
      
      console.log('[GLO] Final color for swatch ' + i + ':', color);

      colors.push(color);
    }

    if (colors.length > 0) {
      var hasNulls = colors.some(function(c) { return c === null; });
      if (hasNulls) {
        console.warn('[GLO] Extracted ' + colors.length + ' colors but some are null. Globo config map has ' + Object.keys(globoColorMap).length + ' entries:', Object.keys(globoColorMap), colors);
      } else {
        console.log('%c[GLO] Extracted ' + colors.length + ' colors from product card:', 'color:#4CAF50;font-weight:bold', colors);
      }
    }

    return colors;
  }

  // Build a color name → {type, value} map from Globo's global config (fallback)
  function buildGloboColorMap() {
    var map = {};
    
    console.log('[GLO] Building color map from window globals...');
    console.log('[GLO] Available Globo globals:', {
      configGloboSwatch: typeof window.configGloboSwatch,
      GloboSwatchConfig: typeof window.GloboSwatchConfig,
      globo_sw_options: typeof window.globo_sw_options,
      productGroupsGloboSwatch: typeof window.productGroupsGloboSwatch,
      productGroupsGloboSwatchNewJs: typeof window.productGroupsGloboSwatchNewJs
    });

    try {
      // Try configGloboSwatch (common structure: { options: [{ name, colors: [{name, color/image}] }] })
      var config = window.configGloboSwatch || window.GloboSwatchConfig;
      if (config) {
        // Structure varies by Globo version. Try common patterns:
        if (config.options && Array.isArray(config.options)) {
          for (var o = 0; o < config.options.length; o++) {
            var opt = config.options[o];
            if (opt.colors && Array.isArray(opt.colors)) {
              for (var c = 0; c < opt.colors.length; c++) {
                var colorItem = opt.colors[c];
                var name = (colorItem.name || colorItem.title || '').toLowerCase().trim();
                if (name) {
                  if (colorItem.image_url || colorItem.image) {
                    map[name] = { type: 'image', value: colorItem.image_url || colorItem.image };
                  } else if (colorItem.color || colorItem.hex || colorItem.value) {
                    map[name] = { type: 'color', value: colorItem.color || colorItem.hex || colorItem.value };
                  }
                }
              }
            }
            if (opt.values && Array.isArray(opt.values)) {
              for (var v = 0; v < opt.values.length; v++) {
                var valItem = opt.values[v];
                var vName = (valItem.name || valItem.title || valItem.label || '').toLowerCase().trim();
                if (vName) {
                  if (valItem.image_url || valItem.image) {
                    map[vName] = { type: 'image', value: valItem.image_url || valItem.image };
                  } else if (valItem.color || valItem.hex || valItem.value) {
                    map[vName] = { type: 'color', value: valItem.color || valItem.hex || valItem.value };
                  }
                }
              }
            }
          }
        }

        // Flat object pattern: { "color_name": "#hex", ... }
        if (typeof config === 'object' && !Array.isArray(config)) {
          var keys = Object.keys(config);
          for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            var val = config[key];
            if (typeof val === 'string' && (val.indexOf('#') === 0 || val.indexOf('rgb') === 0 || val.indexOf('http') === 0)) {
              var keyLower = key.toLowerCase().trim();
              if (val.indexOf('http') === 0) {
                map[keyLower] = { type: 'image', value: val };
              } else {
                map[keyLower] = { type: 'color', value: val };
              }
            }
          }
        }
      }

      // Try globo_sw_options (array of option objects with option_items)
      // Structure: [{ name: "Size", ... }, { name: "Color", option_items: [{value, custom: {color_1, ...}}] }]
      var swOpts = window.globo_sw_options;
      if (swOpts && Array.isArray(swOpts)) {
        for (var sk = 0; sk < swOpts.length; sk++) {
          var swOpt = swOpts[sk];
          if (!swOpt || typeof swOpt !== 'object') continue;

          // Handle option_items array (primary Globo structure for color swatches)
          if (swOpt.option_items && Array.isArray(swOpt.option_items)) {
            for (var oi = 0; oi < swOpt.option_items.length; oi++) {
              var optItem = swOpt.option_items[oi];
              var itemName = (optItem.value || optItem.name || optItem.title || optItem.label || '').toLowerCase().trim();
              if (!itemName || map[itemName]) continue;

              // Extract color from the 'custom' object
              if (optItem.custom) {
                if (optItem.custom.enable_upload_file && optItem.custom.upload_file && optItem.custom.upload_file.server_url) {
                  map[itemName] = { type: 'image', value: optItem.custom.upload_file.server_url };
                } else if (optItem.custom.enable_image_url && optItem.custom.image_url && optItem.custom.image_url.server_url) {
                  map[itemName] = { type: 'image', value: optItem.custom.image_url.server_url };
                } else if (optItem.custom.color_1 && optItem.custom.color_1 !== 'transparent') {
                  map[itemName] = { type: 'color', value: optItem.custom.color_1 };
                }
              } else if (optItem.color || optItem.hex) {
                map[itemName] = { type: 'color', value: optItem.color || optItem.hex };
              } else if (optItem.image_url || optItem.image) {
                map[itemName] = { type: 'image', value: optItem.image_url || optItem.image };
              }
            }
          }

          // Handle values array (legacy structure)
          if (swOpt.values && Array.isArray(swOpt.values)) {
            for (var sv = 0; sv < swOpt.values.length; sv++) {
              var item = swOpt.values[sv];
              var vName = (item.name || item.title || item.label || item.value || '').toLowerCase().trim();
              if (!vName || map[vName]) continue;
              if (item.custom && item.custom.color_1 && item.custom.color_1 !== 'transparent') {
                map[vName] = { type: 'color', value: item.custom.color_1 };
              } else if (item.image_url || item.image) {
                map[vName] = { type: 'image', value: item.image_url || item.image };
              } else if (item.color || item.hex) {
                map[vName] = { type: 'color', value: item.color || item.hex };
              }
            }
          }
        }
      } else if (swOpts && typeof swOpts === 'object' && !Array.isArray(swOpts)) {
        // Flat object fallback: { "color_name": "#hex" }
        var swKeys = Object.keys(swOpts);
        for (var fk = 0; fk < swKeys.length; fk++) {
          var fKey = swKeys[fk];
          var fVal = swOpts[fKey];
          if (typeof fVal === 'string' && (fVal.indexOf('#') === 0 || fVal.indexOf('rgb') === 0)) {
            map[fKey.toLowerCase().trim()] = { type: 'color', value: fVal };
          }
        }
      }
    } catch(e) {
      console.warn('[GLO Quick-Buy] Error reading Globo config:', e);
    }

    // Try productGroupsGloboSwatch / productGroupsGloboSwatchNewJs
    // These contain per-product swatch data: { productId: { options: [...] } }
    try {
      var groupConfigs = [window.productGroupsGloboSwatch, window.productGroupsGloboSwatchNewJs];
      for (var gi = 0; gi < groupConfigs.length; gi++) {
        var groupConfig = groupConfigs[gi];
        if (!groupConfig || typeof groupConfig !== 'object') continue;
        var productIds = Object.keys(groupConfig);
        for (var pi = 0; pi < productIds.length; pi++) {
          var prodData = groupConfig[productIds[pi]];
          if (!prodData) continue;
          // Common structures: prodData.options or prodData.variants array
          var opts = prodData.options || prodData.option_values || [];
          if (Array.isArray(opts)) {
            for (var oi = 0; oi < opts.length; oi++) {
              var optItem = opts[oi];
              var oName = (optItem.name || optItem.label || optItem.title || optItem.value || '').toLowerCase().trim();
              if (!oName) continue;
              if (map[oName]) continue; // don't override existing
              if (optItem.image_url || optItem.image || optItem.swatch_image) {
                map[oName] = { type: 'image', value: optItem.image_url || optItem.image || optItem.swatch_image };
              } else if (optItem.color || optItem.hex || optItem.swatch_color || optItem.bg_color) {
                map[oName] = { type: 'color', value: optItem.color || optItem.hex || optItem.swatch_color || optItem.bg_color };
              }
            }
          }
          // Also check prodData.values (flat array of { name, color })
          var vals = prodData.values || [];
          if (Array.isArray(vals)) {
            for (var vi = 0; vi < vals.length; vi++) {
              var vItem = vals[vi];
              var vn = (vItem.name || vItem.label || vItem.title || '').toLowerCase().trim();
              if (!vn || map[vn]) continue;
              if (vItem.image_url || vItem.image || vItem.swatch_image) {
                map[vn] = { type: 'image', value: vItem.image_url || vItem.image || vItem.swatch_image };
              } else if (vItem.color || vItem.hex || vItem.swatch_color || vItem.bg_color) {
                map[vn] = { type: 'color', value: vItem.color || vItem.hex || vItem.swatch_color || vItem.bg_color };
              }
            }
          }
        }
      }
    } catch(e2) {
      // non-critical
    }

    return map;
  }

  // ---- SET UP LISTENERS ----
  function setupQuickBuyListener() {
    // Listen for the theme's custom dialog event
    document.addEventListener('dialog:after-show', function(e) {
      var modal = e.target;
      if (modal && (modal.tagName === 'QUICK-BUY-MODAL' || modal.classList.contains('quick-buy-modal'))) {
        initGloboInQuickBuyModal(modal);
      }
    });

    // Clean up observers when modal is hidden to prevent memory leaks
    document.addEventListener('dialog:after-hide', function(e) {
      var modal = e.target;
      if (modal && (modal.tagName === 'QUICK-BUY-MODAL' || modal.classList.contains('quick-buy-modal'))) {
        if (modal._globoColorObserver) {
          modal._globoColorObserver.disconnect();
          delete modal._globoColorObserver;
          console.log('%c[GLO Quick-Buy] Cleaned up color observer for modal.', 'color:#9E9E9E;font-weight:bold');
        }
      }
    });

    // Fallback MutationObserver for modals added dynamically after page load
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (node.tagName === 'QUICK-BUY-MODAL' || node.classList.contains('quick-buy-modal'))) {
            if (node.hasAttribute('open') || node.matches(':popover-open')) {
              initGloboInQuickBuyModal(node);
            }
          }
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQuickBuyListener);
  } else {
    setupQuickBuyListener();
  }
})();
